var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{key:_vm.value.key,domProps:{"innerHTML":_vm._s(_vm.value.content)}})
}
var staticRenderFns = []

export { render, staticRenderFns }